
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/discover-companies",
      function () {
        return require("private-next-pages/resources/discover-companies.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/discover-companies"])
      });
    }
  